import { cdnImage } from 'utils/core';
export const EVENTBRITE = 'EVENTBRITE';
export const MAILCHIMP = 'MAILCHIMP';
export const EVENTBRITE_DESCRIPTION_AIRMEET =
    'It allows to synchronize newer registration from eventbrite with Airmeet registrants';
export const SALESFORCE_REDIRECT = 'salesforce';
export const MAILCHIMP_DESCRIPTION_AIRMEET =
    'It allows to push Airmeet registrants to your mailchimp audience mailing list';
export const HUBSPOT = 'HUBSPOT';
export const FACEBOOK_PIXEL = 'FACEBOOK PIXEL';
export const HUBSPOT_DESCRIPTION_AIRMEET =
    'It allows to synchronize newer registration from hubspot with Airmeet registrants';
export const MARKETO = 'MARKETO';
export const MARKETO_DESCRIPTION_AIRMEET =
    'It allows to synchronize new leads from Marketo with Airmeet registrants.';
export const ZAPIER = 'ZAPIER';
export const SALESFORCE = 'SALESFORCE';
export const INTERPREFY = 'INTERPREFY';
export const SALESMATE = 'SALESMATE';
export const ACTIVE_CAMPAIGN = 'ACTIVECAMPAIGN';
export const SLACK = 'SLACK';
export const TWITTER = 'TWITTER';
export const DRIP = 'DRIP';
export const MAILJET = 'MAILJET';
export const GOOGLE_SHEET = 'GOOGLE SHEET';
export const SURVEY_MONKEY = 'SURVEYMONKEY';
export const PIPEDRIVE = 'PIPEDRIVE';
export const PAYPAL = 'PAYPAL';
export const SALESFORCE_PARDOT = 'PARDOT';
export const KEAP = 'KEAP';

export const FACEBOOK_LEAD_ADS = 'FACEBOOK LEAD ADS';
export const LINKEDIN_LEAD_GEN_FORMS = 'LINKEDIN LEAD GEN FORMS';
export const ACCREDIBLE_CERTIFICATES = 'ACCREDIBLE CERTIFICATES';
export const BADGR = 'BADGR';
export const CREDLY = 'CREDLY';
export const AWEBER = 'AWEBER';
export const CUTSOMER_IO = 'CUSTOMER.IO';
export const GETRESPONSE = 'GETRESPONSE';
export const SHARPSPRING = 'SHARPSPRING';
export const INSTAPAGE = 'INSTAPAGE';
export const JOTFORM = 'JOTFORM';
export const UNBOUNCE = 'UNBOUNCE';

export const MICROSOFT_DYNAMICS = 'MICROSOFT DYNAMICS';
export const GOOGLE_TAG_MANAGER = 'GOOGLE TAG MANAGER';
export const POWER_AUTOMATE = 'POWER AUTOMATE';
export const ORACLE_ELOQUA = 'ELOQUA';

//CTA options
export const CONNECT = 'CONNECT';
export const UPGRADE = 'UPGRADE';
export const CONTACT = 'CONTACT US';
export const AIRMEET_LOGO = cdnImage('images/integrations/airmeet.png');

export const integrationText = {
    [EVENTBRITE]: {
        connectModalTitle: 'Connect Eventbrite',
        disconnectModalTitle: 'Disconnect Eventbrite',
        connectModalSubtitle:
            'Add or update registrant list from eventbrite based on your event activity',
        disconnectModalSubtitle:
            'Disconnect your eventbrite account from airmeet.',
        howToConfig: [
            'Enter the Eventbrite Private Token to connect with your Eventbrite account.',
            'Visit the Airmeet Integrations page and enable Eventbrite.',
            "Select the event you wish to connect to that Airmeet, and you're set.",
        ],
        notes: [
            'You will no longer recieve any data configured with Eventbrite once you disconnect the same.',
        ],
        basicInfo:
            "Easily sync Eventbrite event registrations to an Airmeet. Select the event whose participants you'd like to include in an Airmeet, and then all future participants will be added to Airmeet automatically.",
        features:
            'Only Name, Email, Organization, and Designation of the participants will be added to Airmeet. Custom Fields cannot be added.',
        detailPageNotes: [
            'Participants registered on Eventbrite before enabling this integration for the event will not be added automatically. You have to export from Eventbrite and upload a CSV file in Airmeet to add participants.',
            "Do ensure that the Airmeet Entry Rules are set as desired. Select /'Only invited participants' if you want to limit access to participants added from Eventbrite.",
            'Airmeet sends an email to participants on registration and another email when the event is about to start. If you wish to use Eventbrite to send emails to your participants, you can email <a href="mailto:support@airmeet.com" target="_blank">support@airmeet.com</a> to disable participant emails on registration and event reminders.',
        ],
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/support/solutions/articles/82000518377-integrate-airmeet-with-eventbrite" target="_blank">Knowledge base</a> to know more about integrations on Airmeet.',
    },
    [MAILCHIMP]: {
        connectModalTitle: 'Connect Mailchimp',
        disconnectModalTitle: 'Disconnect Mailchimp ',
        connectModalSubtitle:
            'Add or update registrant list from mailchimp based on your event activity',
        disconnectModalSubtitle:
            'Disconnect your mailchimp account from airmeet',
        howToConfig: [
            'Connect with your Mailchimp account.',
            'Visit the Airmeet Integrations page and enable Mailchimp.',
            "Select the audience you wish to connect to that Airmeet, and you're set.",
            'Sync the participant’s direct access link to your contact.',
            'Select the additional registration fields to sync with Mailchimp.',
        ],
        notes: [
            'You will no longer recieve any data configured with Mailchimp once you disconnect the same.',
        ],
        basicInfo:
            "Seamlessly sync your participants with Mailchimp Easily sync Airmeet event registrations to a Mailchimp Audience. Select the audience where you'd like to include your Airmeet registrations, and then all future registrations will be added to the Mailchimp Audience automatically. The contacts added to Mailchimp will be tagged with your event name. The participant’s direct access link will also be added to a MERGE field.",
        features:
            'Only the Name and Email of the participant will be added to Airmeet. Custom Fields will not be added.',
        detailPageNotes: [
            'Participants registered for the Airmeet Event before enabling this integration for the event will not be added to Mailchimp automatically. You have to export from Airmeet and upload those participants in Mailchimp.',
            'Airmeet sends an email to participants on registration and another email when the event is about to start. If you wish to use Mailchimp to send emails to your participants, you can email <a href="mailto:support@airmeet.com" target="_blank">support@airmeet.com</a> to disable participant emails on registration and event reminders.',
        ],
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/support/solutions/articles/82000611860-integrate-airmeet-with-mailchimp" target="_blank">Knowledge base</a> to know more about integrations on Airmeet.',
    },
    [HUBSPOT]: {
        connectModalTitle: 'Connect HubSpot',
        disconnectModalTitle: 'Disconnect HubSpot',
        connectModalSubtitle:
            'Add or update registrant list from hubspot based on your event activity',
        disconnectModalSubtitle: 'Disconnect your hubspot account from airmeet',
        howToConfig: [
            'Connect with your HubSpot account',
            'Visit the Airmeet Integrations page and enable HubSpot',
            'Create a workflow in HubSpot using the Custom Airmeet Action',
        ],
        notes: [
            'Contacts in HubSpot can be filtered based on the Airmeet Name property. Direct Access Link for the event will be added to the contact properties in HubSpot',
        ],
        basicInfo:
            'Easily sync HubSpot contacts with your Airmeet event. Create a custom workflow within HubSpot to enroll contacts to an Airmeet using the Custom Airmeet Action. Contacts enrolled using the workflow will be registered for the Airmeet event.',
        features:
            'Only the Name and Email of the participant will be added to Airmeet. Custom Fields will not be added.',
        detailPageNotes: [
            'Contacts in HubSpot can be filtered based on the Airmeet Name property. Direct Access Link for the event will be added to the contact properties in HubSpot.',
        ],
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/support/solutions/articles/82000879104-integrate-airmeet-with-hubspot-application-v2" target="_blank">Knowledge base</a> to know more about integrations on Airmeet.',
    },
    [MARKETO]: {
        connectModalTitle: 'Connect Marketo',
        disconnectModalTitle: 'Disconnect Marketo',
        connectModalSubtitle:
            'Add or update registrant list from marketo based on your event activity',
        disconnectModalSubtitle: 'Disconnect your Marketo account from airmeet',
        howToConfigDesc:
            'Connect with your Marketo account using the Client ID, Client Secret and REST API Endpoint URL.',
        howToConfig: [
            'Visit the Airmeet Integrations page and enable Marketo.',
            'Click on Save to enable the integration',
            'Create a webhook in Marketo and copy the Webhook url for the event.',
        ],
        notes: [
            'You will no longer recieve any data configured with Marketo once you disconnect the same.',
        ],
        basicInfo:
            'Easily sync Marketo leads with your Airmeet event as participants. Use the event webhook URL provided to create a webhook inside Marketo. Contacts enrolled using the webhook will be registered for the Airmeet event.',
        detailPageNotes: [
            'To push event participants data directly from Airmeet to your Marketo lead list, Use this Zap template via our Zapier integration.',
        ],
        features:
            'Only the Name and Email of the leads from the Marketo list will be added to the participant profile in Airmeet. Custom Fields will not be added.',
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/support/solutions/articles/82000672901-integrate-airmeet-with-marketo" target="_blank">Knowledge base</a> to know more about integrations on Airmeet.',
    },
    [ZAPIER]: {
        connectModalTitle: 'Connect Zapier',
        disconnectModalTitle: 'Disconnect Zapier',
        connectModalSubtitle:
            'Add or update registrant list from zapier based on your event activity',
        disconnectModalSubtitle: 'Disconnect your Zapier account from airmeet',
        howToConfig: [
            'On your browser, search for "zapier.com"',
            'Sign up with the same email/social media you have used for Airmeet.',
            'Connect your Zapier account with Airmeet Organizer Account.',
        ],
        notes: [
            'You will no longer recieve any data configured with zapier once you disconnect the same.',
        ],
        detailPageNotes: [
            'Organizer need to provide  Access key and Secret key at the time of Integration. This can be generated from API access key tab under Integrations from Airmeet.',
        ],
        basicInfo:
            'Zapier is for users who want to update the google sheet attendee list in Airmeet or integrate with Email marketing services such as MailChimp and HubSpot. Once the Zapier account is co-joined with the Airmeet account, all the data in the google sheet will be updated automatically in Airmeet.',
        features:
            'Only the Name and Email of the participant will be added to Airmeet. Custom Fields will not be added.',
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/support/solutions/articles/82000444114-zapier-v2-integrate-sync-multiple-platform-applications-on-airmeet" target="_blank">Knowledge base</a> to know more about integrations on Airmeet.',
    },
    [SALESFORCE]: {
        connectModalTitle: 'Connect Salesforce',
        disconnectModalTitle: 'Disconnect Salesforce',
        connectModalSubtitle:
            'Add or update registrant list from Salesforce based on your event activity',
        disconnectModalSubtitle:
            'Disconnect your Salesforce account from Airmeet',
        howToConfig: [
            'Kindly reach out at support@airmeet.com or visit our 24*7 Support lounge to receive the salesforce application link.',
            'While installing the application kindly log in to the Salesforce dev account on another browser tab simultaneously.',
            'Log in to your Salesforce developer account if not already created and proceed further.',
            'Click on the Install button and provide relevant permissions.',
        ],
        notes: [
            'You will no longer recieve any data configured with Salesforce once you disconnect the same.',
        ],
        basicInfo:
            'Get a holistic view of attendee records by syncing registration details between Airmeet and Salesforce. Accelerate sales pipeline with targeted post-event campaigns and lead nurture programs.',
        detailPageNotes: [
            'It is recommended to keep the event entry set to Only invited participants Event dashboard > Event entry & Participants tab > Edits > Only invited participants.',
        ],
        features:
            'Only the Name and Email of the leads from the Salesforce list will be added to the participant profile in Airmeet.',
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/support/solutions/articles/82000611861-integrate-airmeet-with-salesforce" target="_blank">Knowledge base</a> to know more about integrations on Airmeet.',
    },
    [INTERPREFY]: {
        connectModalTitle: 'Connect Interprefy',
        disconnectModalTitle: 'Disconnect Interprefy',
        connectModalSubtitle:
            'Add or update registrant list from Interprefy based on your event activity',
        disconnectModalSubtitle:
            'Disconnect your Interprefy account from Airmeet',
        howToConfig: [
            'Fill in the  form with your requirements which then will be sent to the Interprefy which you get on clicking connect.',
            'After purchasing the licenses from interprefy, they will issue you a private token key that needs to be entered for that particular session on the event dashboard.',
            'The event organizer can test the interprefy functionality backstage before the event starts via preview mode or during the live event.',
        ],
        notes: [
            'You will no longer recieve any data configured with interprefy once you disconnect the same.',
        ],
        basicInfo:
            'Interprefy offers real-time translation solutions to provide a truly multilingual experience for virtual events participants. In addition, it opens the possibility for event organizers to break the language barriers and reaches a global audience.',
        detailPageNotes: [
            'Participants must mute the session’s original audio to hear the translation (if they do not, they will get both the original audio and the translated audio over the top of each other).',
            "Interprefy doesn't work for RTMP-based sessions (Stream into Airmeet)",
            'Interprefy is not supported in Lite mode for participants.',
            'Currently, Interprefy is not supported in Airmeet mobile browser version & on mobile applications.',
        ],
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/support/solutions/articles/82000660138-set-up-multi-language-interpretation-on-airmeet-via-interprefy" target="_blank">Knowledge base</a> to know more about integrations on Airmeet.',
    },
    [ACTIVE_CAMPAIGN]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to ActiveCampaign',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with ActiveCampaign once you disconnect the same.',
        ],
        basicInfo:
            'With this integration, Zapier will automatically add all new registrants from Airmeet to your ActiveCampaign account as new contacts.',
        introSteps: {
            title: 'Add new Airmeet registrants to ActiveCampaign as contacts',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Registered',
                description: 'When this happens',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create/Update Contact',
                description: 'Then do this',
            },
        },
    },
    [DRIP]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Drip',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with drip once you disconnect the same.',
        ],
        basicInfo:
            'This integration automatically adds all new registrants from Airmeet to your Drip account as subscribers.',
        introSteps: {
            title: 'Add new Airmeet registrants to Drip as subscribers',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Registered',
                description: 'When this happens',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create or Update Subscriber',
                description: 'Then do this',
            },
        },
    },
    [GOOGLE_SHEET]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Google Spreadsheet',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Google Spreadsheet once you disconnect the same.',
        ],
        basicInfo:
            'With this integration, add every new Airmeet registration to a Google Sheets row.',
        introSteps: {
            title: 'Create Google Sheets rows for new Airmeet registrations',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Registered',
                description: 'When this happens',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create Spreadsheet Row',
                description: 'Then do this',
            },
        },
    },
    [MAILJET]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Mailjet',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Mailjet once you disconnect the same.',
        ],
        basicInfo:
            'With this integration, Zapier will automatically add each new registrant from Airmeet to your Mailjet list as a new subscriber. Grow your prospects effortlessly, with every new sign-up recorded for your particular event on Airmeet!',
        introSteps: {
            title: 'Add new registrants from Airmeet as Mailjet subscribers',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Registered',
                description: 'When this happens',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Subscribe Contact to Mailjet List',
                description: 'Then do this',
            },
        },
    },
    [MICROSOFT_DYNAMICS]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Microsoft Dynamics 365 CRM',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Microsoft Dynamics once you disconnect the same.',
        ],
        basicInfo:
            'With this integration, Zapier will automatically add each new registrant from Airmeet to your Microsoft Dynamics list as a new subscriber. Grow your prospects effortlessly, with every new sign-up recorded for your particular event on Airmeet!',
        introSteps: {
            title:
                'Add new registrants from Airmeet to Microsoft Dynamics 365 CRM as contacts',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Registered',
                description: 'When this happens',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create Contact',
                description: 'Then do this',
            },
        },
    },
    [SALESMATE]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Salesmate',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Salesmate once you disconnect the same.',
        ],
        basicInfo:
            'With this integration, Zapier will automatically add all new registrants from Airmeet to your Salesmate account as new contacts. Grow your prospects effortlessly!',
        introSteps: {
            title: 'Add new Airmeet registrants to Salesmate as contacts',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Registered',
                description: 'When this happens',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create Contact',
                description: 'Then do this',
            },
        },
    },
    [SLACK]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Slack',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Slack once you disconnect the same.',
        ],
        basicInfo:
            "Want to keep everyone on your team in the loop about new registrations for your Airmeet events? This Zapier integration allows you to send custom notifications to Slack automatically as soon as a new registrant is added. Plus, you won't have to enable the email notifications for new registrants anymore to stay in the know!",
        introSteps: {
            title: 'Post Slack notifications for new Airmeet registrants',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Registered',
                description: 'When this happens',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Send Channel Message',
                description: 'Then do this',
            },
        },
    },
    [TWITTER]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Twitter',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Twitter once you disconnect the same.',
        ],
        basicInfo:
            "With this Zap, you'll automatically notify your Twitter audience via a new tweet whenever your Airmeet event starts. Grab attendees to your online events without slowing down for manual messaging.",
        introSteps: {
            title: 'Post tweets when new events are live on Airmeet',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Airmeet Start',
                description: 'When this happens',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create Tweet',
                description: 'Then do this',
            },
        },
    },
    [GOOGLE_TAG_MANAGER]: {
        connectModalTitle: ' Add Google Tag Manager',
        disconnectModalTitle: 'Disconnect Google Tag Manager',
        connectModalSubtitle:
            'Please add your Google Tag Manager. This will be added to the event landing page.',
        disconnectModalSubtitle:
            'Disconnect your Google Tag Manager account from airmeet',
        howToConfig: [
            'Enable the integration in the Community Integrations dashboard',
            'Visit the Airmeet Integrations page and enable Google Tag Manager',
            'Add your Google Tag Manager ID',
        ],
        notes: ['Google Tag Manager code will be added to the landing page'],
        basicInfo:
            'Embed Google Tag Manager code on the Airmeet event landing page. Connect Google Tag Manager to Airmeet for improved customer experience through conversion tracking and remarketing with Google Ads, Google Analytics, LinkedIn, Twitter and over 90 supported vendors',
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/en/support/solutions/articles/82000880354-integrate-airmeet-with-google-tag-manager" target="_blank">Knowledge base</a> to know more about integrations on Airmeet',
    },
    [POWER_AUTOMATE]: {
        connectModalTitle: 'Connect Power Automate',
        disconnectModalTitle: 'Disconnect Power Automate',
        connectModalSubtitle:
            'Add or update registrant list from Power Automate based on your event activity',
        disconnectModalSubtitle: 'Disconnect your hubspot account from airmeet',
        howToConfig: [
            'On your browser, visit " https://powerautomate.microsoft.com/ "',
            'Sign in with your Microsoft Account.',
            'Create a new flow with the Airmeet Connector',
            'Connect your Power Automate account to your Airmeet Organizer Account with the Airmeet Access key.',
        ],
        notes: [
            'Organizer needs to provide Access key and Secret key at the time of Integration. This can be generated from the API access key tab under Integrations from Airmeet.',
        ],
        basicInfo:
            'Connect Airmeet to over 500 apps on Microsoft Power Automate Platform, eg. Dynamics 365, Teams. Streamline repetitive tasks and paperless processes with Microsoft Power Automate—so you can focus your attention where it’s needed most.',
        features:
            'With the Power Automate connector, you can add and retrieve event registrations, manage the event listing, setup reminders, track event attendance and more.',
        detailPageNotes: [
            'Organizer needs to provide Access key and Secret key at the time of Integration. This can be generated from the API access key tab under Integrations from Airmeet.',
        ],
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/support/solutions/articles/82000879966-integrate-airmeet-with-microsoft-power-automate" target="_blank">Knowledge base</a> to know more about integrations on Airmeet.',
    },
    [FACEBOOK_PIXEL]: {
        connectModalTitle: ' Add Facebook Pixel ID',
        disconnectModalTitle: 'Disconnect Facebook Pixel',
        connectModalSubtitle:
            'Please add your 15 Or 16 digit Facebook Pixel ID. This will be added to the event landing page.',
        disconnectModalSubtitle:
            'Disconnect your Facebook Pixel account from airmeet',
        howToConfig: [
            'Enable the integration in the Community Integrations dashboard',
            'Visit the Airmeet Integrations page and enable Facebook Pixel',
            'Add your Facebook Pixel ID ',
        ],
        notes: ['Facebook Pixel code will be added to the landing page'],
        basicInfo:
            'Embed Facebook Pixel code on the Airmeet event landing page. Create Custom Audiences for Facebook Ads based on event page visitors. Optimise delivery to people who are likely to take action.',
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/en/support/solutions/articles/82000879915-integrate-airmeet-with-facebook-pixel" target="_blank">Knowledge base</a> to know more about integrations on Airmeet',
    },
    [SURVEY_MONKEY]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Survey Monkey',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with SurveyMoney once you disconnect the same.',
        ],
        basicInfo:
            'This integration will automatically send surveys via SurveyMonkey to your Airmeet event attendees post-event completion.',
        introSteps: {
            title: 'Send SurveyMoney surveys for new finished Airmeet events',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Airmeet Finish',
                description: 'Triggers when an Airmeet is ended by the host.',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Send Survey',
                description:
                    'Send a survey invitation to one or more contacts and/or emails.',
            },
        },
    },
    [PIPEDRIVE]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Pipedrive',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Pipedrive once you disconnect the same.',
        ],
        basicInfo:
            'With this integration, Zapier will automatically add all new registrants from Airmeet to your Pipedrive account as new deals. Grow your prospects effortlessly—every new sign-up is recorded for your particular event on Airmeet!',
        introSteps: {
            title: 'Create Pipedrive deals for new Airmeet registrants',
            step1: {
                action: 'Trigger',
                title: 'Step 1:Airmeet Finish',
                description:
                    'Triggers when a new attendee registers for an Airmeet.',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create Deal',
                description: 'Creates a new deal.',
            },
        },
    },
    [PAYPAL]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to PayPal',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with PayPal once you disconnect the same.',
        ],
        basicInfo:
            'With this integration in place, once your customers make their order on PayPal, you can give them access to your upcoming Airmeet event automatically. Set up this Zap to save yourself from tedious manual updates.',
        introSteps: {
            title: 'Add new PayPal customers as registrants to Airmeet events',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Successful Sale',
                description:
                    'Only successfully completed payments trigger this.',
                notAirmeet: true,
            },
            step2: {
                action: 'Action',
                title: 'Step 2:Add Registrant',
                description: 'Add Registrant To Airmeet',
            },
        },
    },
    [SALESFORCE_PARDOT]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Pardot',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Salesforce Pardot once you disconnect the same.',
        ],
        basicInfo:
            'With this integration, Zapier will automatically add all new registrants from Airmeet to your Pardot account as new prospects. Grow your prospects effortlessly, every new sign up is recorded for your particular event on Airmeet!',
        introSteps: {
            title: 'Add new registrants from Airmeet to Pardot as prospects',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Registered',
                description:
                    'Triggers when a new attendee registers for an Airmeet.',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create Prospect',
                description: 'Creates a new Prospect record within Pardot.',
            },
        },
    },
    [KEAP]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Keap',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with keep once you disconnect the same.',
        ],
        basicInfo:
            'With this integration, Zapier will automatically add all new registrants from Airmeet to your Keap account as new contacts. Grow your prospects effortlessly, every new new sign up is recorded for your particular event on Airmeet!',
        introSteps: {
            title: 'Add new registrants from Airmeet to Keap as contacts',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Registered',
                description:
                    'Triggers when a new attendee registers for an Airmeet.',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create or Update Contact',
                description:
                    'Creates a new contact or updates an existing contact.',
            },
        },
    },
    [FACEBOOK_LEAD_ADS]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Facebook Lead Ads',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Facebook lead ADs once you disconnect the same.',
        ],
        basicInfo:
            'Looking for a quick and easy way to capture Facebook leads in Airmeet? With this Zapier automation, new leads from Facebook Ads are automatically added to Airmeet as registrants.',
        introSteps: {
            title:
                'Create registrants in Airmeet from new leads in Facebook Lead Ads',
            step1: {
                action: 'Trigger',
                title: 'Step 1: New Lead',
                description: 'Triggers when a new lead is created.',
                notAirmeet: true,
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Add Registrant',
                description: 'Add Registrant To Airmeet',
            },
        },
    },
    [LINKEDIN_LEAD_GEN_FORMS]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to LinkedIn Lead Gen Forms',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with LinkedIn Lead Gen once you disconnect the same.',
        ],
        basicInfo:
            'With this Zapier automation, new leads from LinkedIn Lead Gen Forms are automatically added to Airmeet as registrants -- no human error, no human effort. Let this automation work on auto-pilot so that you stay focused on more important tasks.',
        introSteps: {
            title:
                'Create registrants in Airmeet from new LinkedIn Lead Gen Form leads',
            step1: {
                action: 'Trigger',
                title: 'Step 1: New Lead Gen Form Response',
                description: 'Triggers when you receive a new form response.',
                notAirmeet: true,
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Add Registrant',
                description: 'Add Registrant To Airmeet',
            },
        },
    },
    [ACCREDIBLE_CERTIFICATES]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Accredible Certificates',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Accredible Certificates once you disconnect the same.',
        ],
        basicInfo:
            "With this integration, Zapier will automatically create a Accredible Certificates certificate or digital badge every time a new attendee joins an event on Airmeet. It's an easy way to give attendees proof of attendance!",
        introSteps: {
            title:
                'Create Accredible Certificates when new attendees join events on Airmeet',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Joined an Event',
                description: 'Triggers whenever an attendee joins an event',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create Credential',
                description: 'Creates a new certificate or badge.',
            },
        },
    },
    [BADGR]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Badgr',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Badgr once you disconnect the same.',
        ],
        basicInfo:
            'Want to award a badge when someone attends your Airmeet? This integration lets you do that automatically, effortlessly keeping your audience engaged with digital badges from Badgr.',
        introSteps: {
            title:
                'Award Badgr badges when new attendees join Airmeet sessions',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Joined an Event',
                description: 'Triggers whenever an attendee joins an event',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Issue Badge',
                description: 'Creates a new certificate or badge.',
            },
        },
    },
    [CREDLY]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Credly',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Credly once you disconnect the same.',
        ],
        basicInfo:
            'With this integration, Zapier will automatically issue a badge from Credly when an attendee joins an event on Airmeet. This Zap gives you an easy way to give attendees a proof of attendance!',
        introSteps: {
            title:
                'Issue badges in Credly when new attendees join events in Airmeet',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Attendee Joined an Event',
                description: 'Triggers whenever an attendee joins an event',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Issue Badge',
                description: 'Issues a badge.',
            },
        },
    },
    [AWEBER]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to AWeber',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with AWeber once you disconnect the same.',
        ],
        basicInfo:
            'This integration automatically adds all new registrants from the Airmeet event to your Aweber account as subscribers. Keep your outreach on target without the need for duplicate data entry.',
        introSteps: {
            title: 'Add new Airmeet registrants to AWeber as subscribers',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Registrant Added on a Specific Event',
                description: 'Registrant Added on a specific event',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create Subscriber',
                description: 'Creates a new subscriber.',
            },
        },
    },
    [CUTSOMER_IO]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Customer.io',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Customer.io once you disconnect the same.',
        ],
        basicInfo:
            'This integration automatically adds each new registrant from an Airmeet event to your Customer.io account as a person. Set up this Zap to save yourself from tedious duplicate data entry work.',
        introSteps: {
            title: 'Generate Customer.io persons from new Airmeet registrants',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Registrant Added on a Specific Event',
                description: 'Registrant Added on a specific event',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create or Update a Person',
                description:
                    'Creates a new person. If the person already exists, it will be updated.',
            },
        },
    },
    [GETRESPONSE]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to GetResponse',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with GetResponse once you disconnect the same.',
        ],
        basicInfo:
            'Tired of manually managing your contacts across platforms? With this integration, Zapier will automatically add each new registrant from an Airmeet event to your GetResponse account as a new contact.',
        introSteps: {
            title:
                'Add new registrants from Airmeet events to GetResponse as contacts',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Registrant Added on a Specific Event',
                description: 'Registrant Added on a specific event',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create Contact',
                description: 'Creates a new contact.',
            },
        },
    },
    [SHARPSPRING]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to SharpSpring',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with SharpSpring once you disconnect the same.',
        ],
        basicInfo:
            'With this integration, Zapier will automatically add all new registrants from Airmeet event to your SharpSpring account as leads. Every new sign-up is automatically recorded for your particular event on Airmeet. Grow your prospects effortlessly!',
        introSteps: {
            title: 'Save new Airmeet event registrants to SharpSpring as leads',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Registrant Added on a Specific Event',
                description: 'Registrant Added on a specific event',
            },
            step2: {
                action: 'Action',
                title: 'Step 2: Create/Update Lead',
                description:
                    'Create a Lead in SharpSpring or update by email address.',
            },
        },
    },
    [INSTAPAGE]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Instapage',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Instapage once you disconnect the same.',
        ],
        basicInfo:
            'Once activated, this integration will automatically create an Airmeet attendee from a new form submission in Instapage. Let this automation work on auto-pilot so that you stay focused on more important tasks.',
        introSteps: {
            title:
                'Register attendees in Airmeet with custom fields from new form submissions in Instapage',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Form Submission',
                description: 'Triggers when a new form is submitted.',
                notAirmeet: true,
            },
            step2: {
                action: 'Action',
                title:
                    'Step 2: Register Attendee With Custom Registration Form',
                description: 'Register Attendee With Custom Registration Form',
            },
        },
    },
    [JOTFORM]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to JotForm',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with JotForm once you disconnect the same.',
        ],
        basicInfo:
            'Quickly add registrations to Airmeet with this Zapier template. Once this integration is in place, whenever someone new fills out your Jotform form, they will be added as an Airmet registrant automatically.',
        introSteps: {
            title: 'Add Airmeet registrants from new Jotform submissions',
            step1: {
                action: 'Trigger',
                title: 'Step 1: Form Submission',
                description: 'Triggers when a new form is submitted.',
                notAirmeet: true,
            },
            step2: {
                action: 'Action',
                title:
                    'Step 2: Register Attendee With Custom Registration Form',
                description: 'Register Attendee With Custom Registration Form',
            },
        },
    },
    [UNBOUNCE]: {
        howToConfig: [
            'Connect your accounts to Zapier',
            'Choose which data to send to Unbounce',
            'Start automating your work',
        ],
        notes: [
            'You will no longer recieve any data configured with Unbounce once you disconnect the same.',
        ],
        basicInfo:
            'Looking for a quick and easy way to register Unbounce form submissions in Airmeet? With this Zapier automation, each new form submission from Unbounce is added to Airmeet as a registrant, automatically.',
        introSteps: {
            title:
                'Register attendees in Airmeet with custom registration fields from new form submissions in Unbounce',
            step1: {
                action: 'Trigger',
                title: 'Step 1: New Form Submission',
                description:
                    'Triggers when a new Form Submission is received on a Landing Page, Overlay or Sticky Bar',
                notAirmeet: true,
            },
            step2: {
                action: 'Action',
                title:
                    'Step 2: Register Attendee With Custom Registration Form',
                description: 'Register Attendee With Custom Registration Form',
            },
        },
    },
    [ORACLE_ELOQUA]: {
        connectModalTitle: 'Connect Oracle Eloqua',
        disconnectModalTitle: 'Disconnect Oracle Eloqua ',
        connectModalSubtitle:
            'Add or update registrant list from Eloqua based on your event activity',
        disconnectModalSubtitle:
            'Disconnect your Oracle Eloqua account from airmeet',
        howToConfig: [
            'Connect with your Oracle Eloqua account',
            'Visit the Airmeet Integrations page and enable Oracle Eloqua to configure the sync settings',
            'Use the Airmeet Registration Action canvas element on Oracle Eloqua to register users on an Airmeet',
        ],
        notes: [
            'Supports mapping of custom registration fields with Oracle Eloqua contact fields',
            'Contacts in Oracle Eloqua can be filtered based on the Airmeet Name property. Direct Access Link for the event will be added to the contact properties in Oracle Eloqua.',
            'Participants registered for the Airmeet Event before enabling this integration for the event will not be added automatically. You have to export from Airmeet and upload a CSV file in Oracle Eloqua to add those participants.',
            'To disconnect Oracle Eloqua and Airmeet accounts, please disconnect the app on both Airmeet and Oracle Eloqua',
        ],
        basicInfo:
            'Connect Airmeet with your Oracle Eloqua account to create optimized, personalized and cross-channel campaigns to target and engage the right audience at the right time. Target and engage the right audience at the right time while providing real-time reporting and insights using campaign and lead management tools. Add Airmeet Registration Action to your campaign canvas to register users on your Airmeet. Sync registrations received on Airmeet with Oracle Eloqua by enabling the sync on your Airmeet event page.',
        features:
            'Supports mapping of custom registration fields with Oracle Eloqua contact fields',
        detailPageNotes: [
            'Participants registered for the Airmeet Event before enabling this integration for the event will not be added to Mailchimp automatically. You have to export from Airmeet and upload those participants in Mailchimp.',
            'Airmeet sends an email to participants on registration and another email when the event is about to start. If you wish to use Mailchimp to send emails to your participants, you can email <a href="mailto:support@airmeet.com" target="_blank">support@airmeet.com</a> to disable participant emails on registration and event reminders.',
        ],
        knowledge_base:
            'Visit our <a href="https://help.airmeet.com/en/support/solutions/articles/82000884787-integrate-airmeet-with-oracle-eloqua" target="_blank">Knowledge base</a> to know more about integrations on Airmeet.',
    },
};
export const redirectionURL = {
    [ZAPIER]: 'https://zapier.com/apps/airmeet/integrations',
    [INTERPREFY]: 'https://share.hsforms.com/1phsg22j-R06uyv8oLrjGVw3wowi',
    [SALESFORCE]:
        'https://login.salesforce.com/packaging/installPackage.apexp?p0=04t5e0000002lO9',
    [SALESMATE]:
        'https://zapier.com/apps/airmeet/integrations/salesmate/681036/add-new-airmeet-registrants-to-salesmate-as-contacts',
    [ACTIVE_CAMPAIGN]:
        'https://zapier.com/apps/activecampaign/integrations/airmeet/645590/add-new-airmeet-registrants-to-activecampaign-as-contacts',
    [SLACK]:
        'https://zapier.com/apps/airmeet/integrations/slack/686335/post-slack-notifications-for-new-airmeet-registrants',
    [TWITTER]:
        'https://zapier.com/apps/airmeet/integrations/twitter/685177/post-tweets-when-new-events-are-live-on-airmeet',
    [DRIP]:
        'https://zapier.com/apps/airmeet/integrations/drip/681459/add-new-airmeet-registrants-to-drip-as-subscribers',
    [MAILJET]:
        'https://zapier.com/apps/airmeet/integrations/mailjet/681483/add-new-registrants-from-airmeet-as-mailjet-subscribers',
    [GOOGLE_SHEET]:
        'https://zapier.com/apps/airmeet/integrations/google-sheets/645585/create-google-sheets-rows-for-new-airmeet-registrations',
    [MICROSOFT_DYNAMICS]:
        'https://zapier.com/apps/airmeet/integrations/microsoft-dynamics-crm/681011/add-new-registrants-from-airmeet-to-microsoft-dynamics-365-crm-as-contacts',
    [HUBSPOT]: process.env.REACT_APP_HUBSPOT_URL,
    [POWER_AUTOMATE]: process.env.REACT_APP_POWER_AUTOMATE_URL,
    [SURVEY_MONKEY]:
        'https://zapier.com/apps/airmeet/integrations/surveymonkey/737456/send-surveymoney-surveys-for-new-finished-airmeet-events',
    [PIPEDRIVE]:
        'https://zapier.com/apps/airmeet/integrations/pipedrive/737414/create-pipedrive-deals-for-new-airmeet-registrants',
    [PAYPAL]:
        'https://zapier.com/apps/airmeet/integrations/paypal/737342/add-new-paypal-customers-as-registrants-to-airmeet-events',
    [SALESFORCE_PARDOT]:
        'https://zapier.com/apps/airmeet/integrations/pardot/681269/add-new-registrants-from-airmeet-to-pardot-as-prospects',
    [KEAP]:
        'https://zapier.com/apps/airmeet/integrations/keap/681225/add-new-registrants-from-airmeet-to-keap-as-contacts',
    [FACEBOOK_LEAD_ADS]:
        'https://zapier.com/apps/airmeet/integrations/facebook-lead-ads/734758/create-registrants-in-airmeet-from-new-leads-in-facebook-lead-ads',
    [LINKEDIN_LEAD_GEN_FORMS]:
        'https://zapier.com/apps/airmeet/integrations/linkedin-lead-gen-forms/734664/create-registrants-in-airmeet-from-new-linkedin-lead-gen-form-leads',
    [ACCREDIBLE_CERTIFICATES]:
        'https://zapier.com/apps/accredible/integrations/airmeet/760718/create-accredible-certificates-when-new-attendees-join-events-on-airmeet',
    [BADGR]:
        'https://zapier.com/apps/airmeet/integrations/badgr/774668/award-badgr-badges-when-new-attendees-join-airmeet-sessions',
    [CREDLY]:
        'https://zapier.com/apps/airmeet/integrations/credlys-acclaim-platform/760738/issue-badges-in-credly-when-new-attendees-join-events-in-airmeet',
    [AWEBER]:
        'https://zapier.com/apps/airmeet/integrations/aweber/734621/add-new-airmeet-registrants-to-aweber-as-subscribers',
    [CUTSOMER_IO]:
        'https://zapier.com/apps/airmeet/integrations/customerio/734641/generate-customerio-persons-from-new-airmeet-registrants',
    [GETRESPONSE]:
        'https://zapier.com/apps/airmeet/integrations/getresponse/734630/add-new-registrants-from-airmeet-events-to-getresponse-as-contacts',
    [SHARPSPRING]:
        'https://zapier.com/apps/airmeet/integrations/sharpspring/734662/save-new-airmeet-event-registrants-to-sharpspring-as-leads',
    [INSTAPAGE]:
        'https://zapier.com/apps/airmeet/integrations/instapage/810010/register-attendees-in-airmeet-with-custom-fields-from-new-form-submissions-in-instapage',
    [JOTFORM]:
        'https://zapier.com/apps/airmeet/integrations/jotform/810021/add-airmeet-registrants-from-new-jotform-submissions',
    [UNBOUNCE]:
        'https://zapier.com/apps/airmeet/integrations/unbounce/810017/register-attendees-in-airmeet-with-custom-registration-fields-from-new-form-submissions-in-unbounce',
    [ORACLE_ELOQUA]: process.env.REACT_APP_ELOQUA_INSTALL_URL,
};

export const customFieldMapping = {
    HUBSPOT_FEILD_MAPPED: [
        {
            fieldName: 'First Name',
            extFieldName: 'First Name',
        },
        {
            fieldName: 'Last Name',
            extFieldName: 'Last Name',
        },
        {
            fieldName: 'Job Title',
            extFieldName: 'Job Title',
        },
        {
            fieldName: 'Organization',
            extFieldName: 'Company Name',
        },
        {
            fieldName: 'City',
            extFieldName: 'City',
        },
        {
            fieldName: 'Country',
            extFieldName: 'Country/Region',
        },
    ],
    ELOQUA_FEILD_MAPPED: [
        {
            fieldName: 'First Name',
            extFieldName: 'First Name',
        },
        {
            fieldName: 'Last Name',
            extFieldName: 'Last Name',
        },
        {
            fieldName: 'Job Title',
            extFieldName: 'Title',
        },
        {
            fieldName: 'Organization',
            extFieldName: 'Company',
        },
        {
            fieldName: 'City',
            extFieldName: 'City',
        },
        {
            fieldName: 'Country',
            extFieldName: 'Country',
        },
    ],
    MAILCHIMP_FEILD_MAPPED: [
        {
            fieldName: 'First Name',
            extFieldName: 'First Name',
        },
        {
            fieldName: 'Last Name',
            extFieldName: 'Last Name',
        },
    ],
};
